import { User } from "../collections/users";

interface SubscriptionSectionProps {
    user: User;
    applying: boolean;
    updateSubscription: (tier: "free" | "pro", durationDays?: number) => void;
}

export function SubscriptionSection({
    user,
    applying,
    updateSubscription,
}: SubscriptionSectionProps) {
    return (
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                <span>💎</span> Quick Subscription Change
            </h3>
            <div className="flex flex-wrap gap-3">
                <button
                    onClick={() => updateSubscription("free")}
                    disabled={applying || user.subscription_tier === "free"}
                    className="px-5 py-2.5 bg-slate-700 hover:bg-slate-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-all"
                >
                    Set to Free
                </button>
                <button
                    onClick={() => updateSubscription("pro", 30)}
                    disabled={applying}
                    className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-all"
                >
                    Set to Pro (Monthly)
                </button>
                <button
                    onClick={() => updateSubscription("pro", 365)}
                    disabled={applying}
                    className="px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-all"
                >
                    Set to Pro (Yearly)
                </button>
            </div>
            {user.subscription_tier === "pro" && user.subscription_expires_at && (
                <p className="mt-3 text-xs text-slate-400">
                    Current subscription expires on: {new Date(user.subscription_expires_at).toLocaleDateString()}
                </p>
            )}
        </div>
    );
}
